import { AuthProtocolsGetUserInfoResponse, MarqCommonEnumsClientClientTypeEnum } from '~/swagger/data-contracts';
import { LangCode } from './@types';

export const getLangCode = (language: string): LangCode => {
  return language.toLocaleLowerCase().includes('ko') ? 'KO' : 'EN';
};

export const checkIsActiveClient = (userInfo: AuthProtocolsGetUserInfoResponse) => {
  if (!userInfo) {
    return false;
  }

  // 1. Piracy 고객사 체크
  if (userInfo.primary_type === MarqCommonEnumsClientClientTypeEnum.Piracy) {
    return true;
  }

  // 2. 타겟, 제외 Client ID 체크
  // const clientId = userInfo.client_id || -1;
  // if (TARGET_CLIENT_IDs.length === 0) {
  //   return !EXCLUDED_CLIENT_IDS_FOR_HOME_BANNER.includes(clientId);
  // } else if (TARGET_CLIENT_IDs.includes(clientId)) {
  //   return true;
  // } else {
  //   return false;
  // }
  return false;
};

export const attachPmmS3BaseUrl = (fileName: string) => {
  return `https://s3.us-east-2.amazonaws.com/brand.marqvision.com/${fileName}`;
};
